import React from 'react';

const StructuredData = () => {
  const app = {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    "name": "Sales Intercept",
    "applicationCategory": "MarketingSoftware",
    "operatingSystem": "All",
    "offers": {
      "@type": "Offer",
      "price": "49.00",
      "priceCurrency": "USD"
    },
    "aggregateRating": {
      "@type": "AggregateRating",
      "ratingValue": "4.9",
      "ratingCount": "143"
    },
    "url": "https://salesintercept.com"
  };

  const faq = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "How long does setup take?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Most users go live in under five minutes with a single line of code."
        }
      },
      {
        "@type": "Question",
        "name": "Will it slow down my site?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "No. Videos are served via a global CDN in modern formats and lazy‑loaded."
        }
      }
    ]
  };

  return (
    <>
      <script 
        type="application/ld+json" 
        dangerouslySetInnerHTML={{ __html: JSON.stringify(app) }}
      />
      <script 
        type="application/ld+json" 
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faq) }}
      />
    </>
  );
};

export default StructuredData;